class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      const collectionElement = productGridContainer.querySelector('.collection');
      if (collectionElement) {
        collectionElement.classList.add('loading');
      }
    }
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    // Préserver le paramètre view de l'URL actuelle
    const currentUrlParams = new URLSearchParams(window.location.search);
    const viewParam = currentUrlParams.get('view');

    sections.forEach((section) => {
      // Construire l'URL en préservant le paramètre view
      let url = `${window.location.pathname}?section_id=${section.section}`;
      if (searchParams) {
        url += `&${searchParams}`;
      }
      if (viewParam) {
        url += `&view=${encodeURIComponent(viewParam)}`;
      }

      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams, viewParam);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;

    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const newContainer = parsedHTML.getElementById('ProductGridContainer');
    if (newContainer) {
      container.innerHTML = newContainer.innerHTML;
    }
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const productCountElement = parsedHTML.getElementById('ProductCount');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (!productCountElement || !container) return;

    const count = productCountElement.innerHTML;
    container.innerHTML = count;
    container.classList.remove('loading');

    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter, #CollectionFiltersForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const existingElement = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (existingElement) {
        existingElement.innerHTML = element.innerHTML;
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    // Synchroniser les checkboxes et colorSwatch dans le drawer après la mise à jour
    FacetFiltersForm.syncDrawerFilters(parsedHTML);

    // Mettre à jour tous les .collection-filter-count avec le nombre de produits (filtré)
    // Ne modifier que le nombre pour préserver .collection-filter-count-text
    const sourceCountEl = parsedHTML.querySelector('.collection-filter-count');
    if (sourceCountEl) {
      const count = sourceCountEl.dataset.collectionProductsCount ?? sourceCountEl.querySelector('.collection-filter-count-number')?.textContent?.trim() ?? sourceCountEl.textContent.trim();
      document.querySelectorAll('.collection-filter-count').forEach((el) => {
        const numberEl = el.querySelector('.collection-filter-count-number');
        if (numberEl) {
          numberEl.textContent = count;
        } else {
          el.textContent = count;
        }
        if (el.dataset) el.dataset.collectionProductsCount = count;
      });
    }
  }

  static syncDrawerFilters(parsedHTML) {
    const drawerForm = document.getElementById('CollectionFiltersForm');
    if (!drawerForm) return;

    // Récupérer tous les checkboxes du drawer
    const drawerCheckboxes = drawerForm.querySelectorAll('input[type="checkbox"]');

    drawerCheckboxes.forEach((checkbox) => {
      // Trouver le checkbox correspondant dans le HTML parsé
      const name = checkbox.getAttribute('name');
      const value = checkbox.getAttribute('value');
      if (!name || !value) return;

      // Échapper les caractères spéciaux pour le sélecteur
      const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const escapedValue = value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const correspondingCheckbox = parsedHTML.querySelector(`#CollectionFiltersForm input[name="${escapedName}"][value="${escapedValue}"]`);

      if (correspondingCheckbox) {
        // Synchroniser l'état checked
        const isChecked = correspondingCheckbox.checked || correspondingCheckbox.hasAttribute('checked');
        checkbox.checked = isChecked;
        checkbox.disabled = correspondingCheckbox.disabled || correspondingCheckbox.hasAttribute('disabled');

        // Synchroniser la classe selected sur colorSwatch
        const colorSwatch = checkbox.closest('label')?.querySelector('.colorSwatch');
        if (colorSwatch) {
          if (isChecked) {
            colorSwatch.classList.add('selected');
          } else {
            colorSwatch.classList.remove('selected');
          }
        }
      }
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const targetElement = document.querySelector(selector);
      if (targetElement) {
        targetElement.innerHTML = html.querySelector(selector).innerHTML;
      }
    });

    const facetFiltersFormMobile = document.getElementById('FacetFiltersFormMobile');
    if (facetFiltersFormMobile) {
      const menuDrawer = facetFiltersFormMobile.closest('menu-drawer');
      if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
        menuDrawer.bindEvents();
      }
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams, viewParam = null) {
    // Préserver le paramètre view si présent
    if (!viewParam) {
      const currentUrlParams = new URLSearchParams(window.location.search);
      viewParam = currentUrlParams.get('view');
    }

    // Construire l'URL en utilisant searchParams directement, sans re-parser/re-encoder.
    // Re-encoder via URLSearchParams double-encode les '+' (espaces) en '%2B',
    // ce qui casse les filtres Shopify qui attendent '+' pour les espaces.
    const parts = [];

    if (searchParams && searchParams.trim()) {
      parts.push(searchParams);
    }

    if (viewParam) {
      parts.push('view=' + encodeURIComponent(viewParam));
    }

    let url = window.location.pathname;
    if (parts.length > 0) {
      url += '?' + parts.join('&');
    }

    history.pushState({ searchParams }, '', url);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    // S'assurer que searchParams est une chaîne valide
    if (!searchParams || searchParams.trim() === '') {
      searchParams = '';
    }
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

    // Vérifier si c'est un clic sur une checkbox mobile
    if (event.srcElement && event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const targetForm = event.target ? event.target.closest('form') : (event.currentTarget || null);
      const isMobile = targetForm && targetForm.id === 'FacetFiltersFormMobile';
      const isCollectionDrawer = targetForm && targetForm.id === 'CollectionFiltersForm';

      sortFilterForms.forEach((form) => {
        if (!isMobile && !isCollectionDrawer) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            const formParams = this.createSearchParams(form);
            if (formParams) {
              forms.push(formParams);
            }
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          const formParams = this.createSearchParams(form);
          if (formParams) {
            forms.push(formParams);
          }
        } else if (form.id === 'CollectionFiltersForm') {
          const formParams = this.createSearchParams(form);
          if (formParams) {
            forms.push(formParams);
          }
        }
      });

      const finalSearchParams = forms.filter(p => p && p.trim()).join('&');
      this.onSubmitForm(finalSearchParams, event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

// Correction des URLs mal-encodées générées par un ancien bug.
// Les '+' (espaces) dans les noms d'options Shopify étaient double-encodés en '%2B',
// ce qui empêchait le rendu serveur de trouver les produits filtrés.
// On corrige et on recharge pour que Shopify reçoive la bonne URL.
(function correctFilterUrlEncoding() {
  const search = window.location.search;
  if (!search.includes('filter.') || !search.toLowerCase().includes('%2b')) return;
  const corrected = search.replace(/%2B/gi, '+');
  if (corrected !== search) {
    window.location.replace(window.location.pathname + corrected + window.location.hash);
  }
})();

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class CollectionFiltersDrawer extends HTMLElement {
  constructor() {
    super();
    this.handleOverlayClick = this.handleOverlayClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEscape = this.handleEscape.bind(this);
    this.handleFilterSubmitClick = this.handleFilterSubmitClick.bind(this);
  }

  connectedCallback() {
    this.overlay = this.querySelector('.collection-filters-drawer-overlay');
    this.container = this.querySelector('.collection-filters-drawer-container');
    this.closeButton = this.querySelector('.collection-filters-drawer-close');
    this.submitButton = this.querySelector('.collection-filters-drawer-submit');
    this.form = this.querySelector('#CollectionFiltersForm');

    if (this.overlay) {
      this.overlay.addEventListener('click', this.handleOverlayClick);
    }
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.handleClose);
    }
    if (this.submitButton) {
      this.submitButton.addEventListener('click', this.handleSubmit);
    }

    document.addEventListener('keydown', this.handleEscape);
    this.setupFilterSubmitListener();
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleEscape);
    this.removeFilterSubmitListener();
  }

  setupFilterSubmitListener() {
    // Écouter les clics sur le bouton collection-filter-submit
    const submitButton = document.querySelector('.collection-filter-submit');
    if (submitButton) {
      submitButton.addEventListener('click', this.handleFilterSubmitClick);
    }
  }

  removeFilterSubmitListener() {
    const submitButton = document.querySelector('.collection-filter-submit');
    if (submitButton) {
      submitButton.removeEventListener('click', this.handleFilterSubmitClick);
    }
  }

  handleFilterSubmitClick(e) {
    e.preventDefault();
    this.open();
  }

  open(filterIndex = null) {
    this.classList.add('is-open');
    document.body.classList.add('collection-filters-drawer-open');

    // Ouvrir le filtre spécifique si fourni
    if (filterIndex) {
      setTimeout(() => {
        const filterDetails = this.querySelector(`[data-index="drawer-${filterIndex}"]`);
        if (filterDetails && filterDetails.tagName === 'DETAILS') {
          filterDetails.setAttribute('open', '');
        }
      }, 100);
    }
  }

  close() {
    this.classList.remove('is-open');
    document.body.classList.remove('collection-filters-drawer-open');
  }

  handleOverlayClick(event) {
    if (event.target === this.overlay) {
      this.close();
    }
  }

  handleClose(event) {
    event.preventDefault();
    this.close();
  }

  handleEscape(event) {
    if (event.key === 'Escape' && this.classList.contains('is-open')) {
      this.close();
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    // Le bouton "VOIR LES RÉSULTATS" sert simplement à fermer le drawer
    // Les filtres sont déjà appliqués automatiquement via les événements 'input'
    // qui déclenchent debouncedOnSubmit dans FacetFiltersForm (avec un délai de 500ms)
    // Donc on ferme simplement le drawer sans soumettre à nouveau le formulaire

    this.close();
  }
}

customElements.define('collection-filters-drawer', CollectionFiltersDrawer);
